import { createContext, useContext, useEffect, useState } from 'react';

const TenantConfigContext = createContext(null);

const initialState = {
  username: null,
  client: null,
  usertype: null,
  disableAnalytics: false,
  onlyAttachment: false,
  disabledPages: [],
  enableStudyPageImage: false,
};

export function TenantConfigProvider({ children }) {
  // Initialize from localStorage on mount (handles page refresh)
  const [config, setConfig] = useState(() => ({
    username: localStorage.getItem('username'),
    client: localStorage.getItem('client'),
    usertype: null, // Not persisted to localStorage
    disableAnalytics: localStorage.getItem('disableAnalytics') === 'true',
    onlyAttachment: localStorage.getItem('only_attachment') === 'true',
    enableStudyPageImage: localStorage.getItem('enableStudyPageImage') === 'true',
  }));

  // Sync to localStorage whenever config changes
  useEffect(() => {
    if (config.username) {
      localStorage.setItem('username', config.username);
    }
    if (config.client) {
      localStorage.setItem('client', config.client);
    }
    localStorage.setItem('disableAnalytics', config.disableAnalytics ? 'true' : 'false');
    localStorage.setItem('only_attachment', config.onlyAttachment ? 'true' : 'false');
    localStorage.setItem('enableStudyPageImage', config.enableStudyPageImage ? 'true' : 'false');
  }, [config]);

  const updateConfig = (newConfig) => {
    setConfig((prev) => ({ ...prev, ...newConfig }));
  };

  const clearConfig = () => {
    setConfig(initialState);
    localStorage.removeItem('username');
    localStorage.removeItem('client');
    localStorage.removeItem('disableAnalytics');
    localStorage.removeItem('only_attachment');
    localStorage.removeItem('disabledPages');
    localStorage.removeItem('enableStudyPageImage');
  };

  return (
    <TenantConfigContext.Provider value={{ config, updateConfig, clearConfig }}>
      {children}
    </TenantConfigContext.Provider>
  );
}

export function useTenantConfig() {
  const context = useContext(TenantConfigContext);
  if (!context) {
    throw new Error('useTenantConfig must be used within TenantConfigProvider');
  }
  return context;
}
